import { useMutation } from "@tanstack/react-query";
import { downloadFiles } from "./index";

export const useDownloadFiles = () => {
  return useMutation({
    mutationFn: downloadFiles,
  });
};
